/* eslint-disable react/prop-types */
import React from 'react';
import Price from './Price';
import Image from './Image';
import GenericButton from './GenericButton';
import { useSelector } from 'react-redux';
import { isChrome, isIOS, isMobile, isSafari } from 'react-device-detect';

/**
 *
 * @param props.imageFileName
 * @param props.imageAlt
 * @param props.title
 * @param props.description
 * @param props.price
 * @param props.discount
 * @param props.startingAt
 * @param props.isInsuranceLoading
 * @param props.isInsuranceEnabled
 * @param props.isBestPrescription
 * @param props.handleClick
 * @param props.isLearnMore
 * @param props.isLearnMoreSelected
 * @param props.handleAddButton
 * @param props.dataElementId
 * @param props.dataDescription
 * @param props.className
 * @param props.tabIndex
 *
 */
const StepButton = props => {
    const currentStep = useSelector(state => state.main.currentStep);
    const labels = useSelector(state => state.main.labels);
    const baseURLs = useSelector(state => state.main.baseURLs);
    const isPrescriptionModalOpen = useSelector(state => state.main.isPrescriptionModalOpen);
    const isGVP = useSelector(state => state.main.isGVP);

    //Handles step tabIndex
    const addButtonTabIndex = props.tabIndex ? (parseInt(props.tabIndex) + 1).toString() : '0';

    const stepButtonTabIndex = () => {
        if (!props.isLearnMore) {
            if (props.tabIndex || isPrescriptionModalOpen) {
                return '-1';
            } else {
                return '0';
            }
        } else {
            return props.tabIndex;
        }
    };

    return (
        <div className="step-button-container">
            <button
                className={
                    'step-button' +
                    (props.className ? props.className : '') +
                    (props.isInsuranceLoading ? ' step-disabled' : '') +
                    (props.isLearnMoreSelected ? ' step-button-selected' : '') +
                    (isSafari ? ' safari' : '') +
                    (isIOS && isChrome ? ' chrome-ios' : '')
                }
                data-element-id={props.dataElementId}
                data-description={props.dataDescription}
                onClick={props.handleClick}
                ref={props.firstLearnMore}
                disabled={props.isInsuranceLoading}
                tabIndex={stepButtonTabIndex()}
            >
                <div className="step-button-layout">
                    <div className="step-button-image-container">
                        <Image
                            imageClass="step-button-image"
                            url={baseURLs.projectImage}
                            fileName={props.imageFileName}
                            alt={props.imageAlt}
                        />
                    </div>

                    <div className="step-button-badge-container">
                        {props.isBestPrescription && (
                            <div className="step-button-badge best-prescription-badge">
                                {labels.prescription.bestPrescription}
                            </div>
                        )}

                        {props.badge && !props.onlyOne && (
                            <div className="step-button-badge most-popular-badge">
                                {props.badge}
                            </div>
                        )}
                    </div>

                    <div className="step-button-content">
                        <div className="step-button-title">{props.title}</div>
                        {props.subtitle && (
                            <div className="step-button-subtitle">{props.subtitle}</div>
                        )}
                        {props.price == undefined && !props.isLearnMoreSelected ? (
                            <div
                                className="step-button-desc"
                                dangerouslySetInnerHTML={{ __html: props.description }}
                            ></div>
                        ) : null}
                        {props.price !== undefined ? (
                            <div className="step-button-price">
                                <Price
                                    value={props.price}
                                    discount={props.discount}
                                    startingAt={props.startingAt}
                                    isInsuranceLoading={props.isInsuranceLoading}
                                    isInsuranceEnabled={props.isInsuranceEnabled}
                                    isGVPPrice={isGVP && !props.isInsuranceEnabled}
                                />
                            </div>
                        ) : null}
                        {((isMobile && props.isLearnMore) ||
                            (!isMobile && props.isLearnMoreSelected)) &&
                            props.description && (
                                <div
                                    className="step-button-desc-learn-more"
                                    dangerouslySetInnerHTML={{ __html: props.description }}
                                ></div>
                            )}
                        {isMobile && props.isLearnMore && (
                            <div className="step-button-add">
                                {props.isLearnMoreSelected && (
                                    <GenericButton
                                        className="border-button add-button"
                                        handleClick={props.handleAddButton}
                                        dataElementId={
                                            'X_X_LensPanel_' +
                                            labels.stepAnalyticsName[currentStep] +
                                            '-LearnMoreChoose'
                                        }
                                        dataDescription={
                                            props.subtitle ? props.subtitle : props.title
                                        }
                                        title="Add"
                                    >
                                        {labels.add}
                                    </GenericButton>
                                )}
                            </div>
                        )}
                    </div>

                    {!isMobile && props.isLearnMoreSelected && (
                        <div className="step-button-add">
                            <GenericButton
                                tabIndex={addButtonTabIndex}
                                className="border-button add-button"
                                handleClick={props.handleAddButton}
                                dataElementId={
                                    'X_X_LensPanel_' +
                                    labels.stepAnalyticsName[currentStep] +
                                    '-LearnMoreChoose'
                                }
                                dataDescription={props.subtitle ? props.subtitle : props.title}
                                title="Add"
                                noArrow
                            >
                                {labels.add}
                            </GenericButton>
                        </div>
                    )}
                </div>
            </button>
        </div>
    );
};

export default StepButton;
